import { rem } from 'polished'
import styled from 'styled-components'

import Card from '../../shared/Card'

export const FeatureFigure = styled.div`
  max-width: 220px;
  margin-bottom: 32px;
`

export const FeatureCaption = styled.div``

export const FeatureTitle = styled.h3`
  color: ${({ theme }) => theme.color.neutral900};
  font-weight: 700;
  font-size: ${rem(16)};
  letter-spacing: 0.5px;
  margin-bottom: 18px;
  text-transform: uppercase;
`

export const FeatureText = styled.p``

export const FeatureFooting = styled.div`
  margin-top: 24px;
`

export const FeatureWrapper = styled(Card)`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: ${({ align }) => (align === 'center' ? align : 'left')};
  align-items: ${({ align }) => align};
  height: 100%;
  z-index: ${(props) => props.zindex};
  ${({ translateY }) =>
    translateY &&
    `
    transform: translateY(${translateY}%);
  `}

  ${({ theme, light }) =>
    light &&
    `
      color: ${theme.color.white};

      ${FeatureTitle} {
        color: ${theme.color.white};
      }
  `}
`
